/**
 * @fileoverview Weather theme - match weather condition emojis.
 */

import { ThemeOptions } from '../../../services/ThemeService.js';
import { EmojiMatchingTheme } from '../../abstract/EmojiMatchingTheme.js';
import { allLabels } from '../../Labels.js';

/**
 * Weather theme with sun, clouds, rain, and more.
 */
export class WeatherTheme extends EmojiMatchingTheme {
    constructor(options: ThemeOptions = {}) {
        super(
            'weather',
            'Weather',
            allLabels.weather,
            { numPairs: 3, isPremium: false, hasMovement: false, ...options }
        );
    }
}
